import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { TranslateService } from 'app/i18n/translate.service';

@Pipe({
  name: 'timeSinceNow',
  pure: true
})
export class TimeSinceNowPipe implements PipeTransform {
  lang: string = 'en';

  constructor(private translate: TranslateService) {
    this.translate
      .onLangChanged
      .subscribe((lang) => {
        this.lang = lang;
      })
  }

  transform(date: string) {
    const dateToFormat = !!(+date) ? parseInt(date) : date;

    return dateToFormat
      ? moment(dateToFormat).locale(this.lang).fromNow()
      : '';
  }
}


// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/shared/pipes/time-since-now.pipe.ts